import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
      specialPayMerchantObj:{}
    },
    mutations: {
        modifySpecialPayMerchantObj(state,{pushObj}){
            // 如果传入值的商户id与与原id不同
            if (state.specialPayMerchantObj.merchantId != pushObj.merchantId) {
                state.specialPayMerchantObj = {...pushObj}
            }else{
                // id相同观察内部的doorList
                state.specialPayMerchantObj.doorList = pushObj.doorList
            }
         
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js